import { Component } from '@angular/core';

@Component({
    selector: 'app-producto',
    templateUrl: './producto.component.html',
    styleUrls: ['./producto.component.scss']
})
export class ProductoComponent {}
